import React from 'react';

import {InsightsPreferences} from 'insights/InsightsConstants';
import preferences from 'Preferences';
import ProjectSelector from 'ui-library/ProjectSelector';

export interface AnalyticsProjectSelectorProps {
  onChange: (projectId: string) => void;
  projectId: string | null;
}

/**
 * Typesafe wrapper for ConnectedProjectSelector that saves the last selected project into a user preference
 *
 * This is a controlled component, so the caller should manage the projectId state. To initialize the state,
 * use getDefaultProjectId for the last selected project.
 *
 */
export default function AnalyticsProjectSelector(props: AnalyticsProjectSelectorProps): JSX.Element {
  return (
    <ProjectSelector
      onProjectSelected={props.onChange}
      selectedProjectId={props.projectId}
      enableRedesign={true}
      preferenceKey={InsightsPreferences.PROJECT_ID}
    />
  );
}

/**
 * Return the last selected project
 */
export function getDefaultProjectId(): string | null {
  return preferences.get(InsightsPreferences.PROJECT_ID) ?? null;
}
